import { ConcessionStore } from '../../../../core/api/restaurant/restaurant.types';
import { BasketItemType } from '../../../../core/types/basket.types';
import * as BasketControl from '../../../../weborder/BasketControl';

interface SumarisedBasket {
  [index: string]: any;
}

const summariseBasketItems = (items): BasketItemType[] => {
  const counts: any = {};

  for (let i = 0; i < items.length; i += 1) {
    const item = items[i];

    const optionList = item.Options.map((o) => o.Name).join(', ');
    const optionTotal = BasketControl.ItemTotal(item);
    const key = `${item.Item.Name}//${optionList}//${optionTotal}`;

    if (counts[key]) {
      counts[key].quantity += 1;
      counts[key].index = i;
      counts[key].item = item.Item;
      counts[key].options = item.Options;
    } else {
      counts[key] = {
        item: item.Item,
        index: i,
        options: item.Options,
        quantity: 1,
      };
    }
  }

  return counts;
};

const refactorBasketSnapshot = (snapshotData: SumarisedBasket) =>
  Object.entries(snapshotData).reduce((acc, [key, i]) => {
    acc[key] = {
      item: i.item.Item,
      index: i.index,
      quantity: i.quantity,
      options: i.item.Options,
    };
    return acc;
  }, {});

const summariseConcessionBasketItems = (
  sumarisedItems: BasketItemType[] | SumarisedBasket,
): any => {
  const itemsByConcessionId: any = {};
  const basketItemsArray = Object.entries(sumarisedItems);

  basketItemsArray.forEach((item) => {
    const key = item[1].item.ConcessionStoreId;
    const [itemName, itemData] = item;

    if (itemsByConcessionId[key]) {
      itemsByConcessionId[key].push({
        itemName,
        itemData,
      });
    } else {
      itemsByConcessionId[key] = [
        {
          itemName,
          itemData,
        },
      ];
    }
  });

  return itemsByConcessionId;
};

const getConcessionBrand = (id, concessionStores): ConcessionStore =>
  concessionStores.find(
    (store: ConcessionStore) => store?.ConcessionStoreId === id,
  );

const getBasketItemKey = (basketItem: BasketItemType | any): string => {
  const { item, options } = basketItem;
  let key = item?.MenuItemId?.toString() || '';
  for (let i = 0; i < options?.length; i += 1) {
    key += `-${options[i].MenuItemOptionSetItemId}`;
  }
  return key;
};

export const basketUtils = {
  getBasketItemKey,
  getConcessionBrand,
  refactorBasketSnapshot,
  summariseBasketItems,
  summariseConcessionBasketItems,
};
